<template>
  <modal
    :modal-title="'Edit Participant'"
    :icon="'fa-plus-circle'"
    :modal-id="'edit-participant-modal'"
  >
    <template slot>
      <form
        class="tdesk-form"
        @submit.prevent="checkEmail()"
      >
        <div class="row">
          <div class="col-md-12">
            <div class="form-group required">
              <label for="email">Contact email</label>
              <input
                id="email"
                v-model="participant.email"
                type="email"
                required
              >
            </div>
            <notice
              v-if="emailInUse"
              :message="'This email address has already been added to this order'"
              style="margin-bottom: 10px;"
              :importance="'secondary'"
              :type="'warning'"
            />
            <button
              v-if="!emailChecked"
              class="tdesk-secondary-button"
              type="submit"
              :disabled="!participant.email"
            >
              <i class="fas fa-caret-right" />
              Next
            </button>
          </div>
        </div>
      </form>
      <form
        v-if="emailChecked"
        class="tdesk-form"
        @submit.prevent="handleSubmit()"
      >
        <div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group required">
                <label for="first_name">First name</label>
                <div
                  v-tooltip:top="participant.existing_account ? 'An account using this email address was found' : null"
                  tabindex="0"
                  style="position: relative; display: inline-block;"
                  data-toggle="tooltip"
                  class="tdesk-tooltip"
                >
                  <div
                    v-if="participant.existing_account"
                    style="position:absolute;height: 100%;width:100%; cursor:not-allowed"
                  />
                  <input
                    id="first_name"
                    v-model="participant.first_name"
                    type="text"
                    :disabled="participant.existing_account"
                    required
                  >
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group required">
                <label for="last_name">Last name</label>
                <div
                  v-tooltip:top="participant.existing_account ? 'An account using this email address was found' : null"
                  tabindex="0"
                  style="position: relative; display: inline-block;"
                  data-toggle="tooltip"
                  class="tdesk-tooltip"
                >
                  <div
                    v-if="participant.existing_account"
                    style="position:absolute;height: 100%;width:100%; cursor:not-allowed"
                  />
                  <input
                    id="last_name"
                    v-model="participant.last_name"
                    type="text"
                    :disabled="participant.existing_account"
                    required
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="mobile_phone">Mobile phone number</label>
          <input
            id="mobile_phone"
            v-model="participant.mobile_phone"
            type="text"
          >
        </div>
        <div
          v-if="participant.phone_number_changed"
          class="tdesk-primary-notice info"
        >
          <i class="fal" />
          Training Desk will also use this updated phone number in your
          contact details.
        </div>
        <div class="form-group checkbox">
          <input
            id="pre_course_acknowledged"
            v-model="participant.pre_course_acknowledged"
            type="checkbox"
            value="true"
            required
          >
          <label for="pre_course_acknowledged" style="margin-left: 7px;">
            I understand that I will have to complete any required pre-course
            work
          </label>
        </div>
        <div class="form-group checkbox">
          <input
            id="physically_able_acknowledged"
            v-model="participant.physically_able_acknowledged"
            type="checkbox"
            value="true"
            required
          >
          <label for="physically_able_acknowledged" style="margin-left: 7px;">
            I confirm that I am physically able to complete this course
          </label>
        </div>
        <div id="form-errors" class="form-errors">
          <form-errors :errors="errors" />
        </div>
        <div style="display:flex;justify-content: flex-end">
          <button class="tdesk-primary-button" type="submit">
            <i class="fas fa-plus-circle fa-fw" />
            Save student
          </button>
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
  import Modal from '../../modal';
  import Notice from '../../tdesk_notice';
  import FormErrors from "../../form_errors";

  export default {
    components: {Modal, Notice, FormErrors},
    props: {
      order: {
        required: true,
        type: Object,
      },
      activeParticipant: {
        required: true,
        type: Object,
      },
    },
    data() {
      return {
        submitted: false,
        errors: [],
        emailChecked: true,
        emailInUse: false,
        participant: {
          id: this.activeParticipant.id,
          first_name: this.activeParticipant.first_name,
          last_name: this.activeParticipant.last_name,
          mobile_phone: this.activeParticipant.mobile_phone,
          pre_course_acknowledged: this.activeParticipant.pre_course_acknowledged,
          physically_able_acknowledged: this.activeParticipant.physically_able_acknowledged,
          locked: this.activeParticipant.locked,
          email: this.activeParticipant.email,
          existing_account: this.activeParticipant.existing_account,
        },
      };
    },
    computed: {
      mobile_phone() {
        return this.participant.mobile_phone;
      },
      email() {
        return this.participant.email;
      },
      capacityReached() {
        return this.order.participants.length >= this.order.placesRequired;
      },
      valid() {
        return this.participant.first_name && this.participant.pre_course_acknowledged && this.participant.physically_able_acknowledged && this.participant.email;
      },
    },
    watch: {
      email() {
        if (this.participant.email === this.activeParticipant.email) {
          return;
        }
        if (!this.emailChecked) {
          return;
        }
        let email = this.email;
        this.resetForm();
        this.participant.email = email;
        this.$nextTick(() => this.emailChecked = false);
      },
      mobile_phone(newValue, oldValue) {
        if (this.participant.mobile_phone === this.activeParticipant.mobile_phone) {
          return;
        }
        if (!oldValue || !this.participant.existing_account) {
          return;
        }
        this.participant.phone_number_changed = true;
      },
    },
    mounted() {
      this.openModal();
      let self = this;
      $('#edit-participant-modal').on('hidden.bs.modal', function () {
        self.closeModal();
      });
      $('#edit-participant-modal').on('shown.bs.modal', function () {
        self.openModal();
      });
    },
    methods: {
      handleSubmit() {
        this.handleFormErrors();
        if (this.submitted || !this.valid || this.errors.length > 0) {
          return;
        }
        this.submitted = true;
        this.$emit('modify-participant', this.participant);
        this.closeModal();
      },
      checkEmail() {
        let email = this.participant.email;
        let emailAlreadyUsed = this.order.participants.filter(p => p.email.toLowerCase() === email.toLowerCase()).length > 0;
        if (emailAlreadyUsed) {
          return this.emailInUse = true;
        }
        this.emailInUse = false;
        let data = {
          email: this.participant.email,
          cid: this.order.course.id,
        };
        let url = Routes.trainer_conflict_check_enrols_path();
        axios
            .post(url, data)
            .then(rsp => {
              if (rsp.data.error) {return this.errors = [rsp.data.error];}
              this.checkEmailForExistingAccount();
            });
      },
      checkEmailForExistingAccount() {
        let email = this.participant.email;
        let url = Routes.account_existence_check_enrols_path({email: email});
        axios
            .get(url)
            .then(response => {
              let user = response.data.user;
              if (user) {
                this.participant.first_name = user.first_name;
                this.participant.last_name = user.last_name;
                this.participant.mobile_phone = user.mobile_phone;
                this.participant.email = user.email;
                this.participant.phone_number_changed = false;
                this.participant.existing_account = true;
              }
              this.emailChecked = true;
            });
      },
      handleFormErrors() {
        if (!this.participant.first_name && !this.errors.includes('First name is required')) {
          this.errors.push('First name is required');
        }
        if (!this.participant.pre_course_acknowledged && !this.errors.includes('You must agree to the statements')) {
          this.errors.push('You must agree to the statements');
        }
        if (!this.participant.physically_able_acknowledged && !this.errors.includes('You must agree to the statements')) {
          this.errors.push('You must agree to the statements');
        }
        if (!this.participant.email && !this.errors.includes('Email is required')) {
          this.errors.push('Email is required');
        }
      },
      resetForm() {
        this.emailChecked = false;
        this.participant = {
          id: this.activeParticipant.id,
          first_name: null,
          last_name: null,
          mobile_phone: null,
          pre_course_acknowledged: false,
          physically_able_acknowledged: false,
          locked: false,
          email: null,
          existing_account: false,
        };
        this.submitted = false;
      },
      openModal() {
        this.participant = {
          id: this.activeParticipant.id,
          first_name: this.activeParticipant.first_name,
          last_name: this.activeParticipant.last_name,
          mobile_phone: this.activeParticipant.mobile_phone,
          pre_course_acknowledged: this.activeParticipant.pre_course_acknowledged,
          physically_able_acknowledged: this.activeParticipant.physically_able_acknowledged,
          locked: this.activeParticipant.locked,
          email: this.activeParticipant.email,
          existing_account: this.activeParticipant.existing_account,
        };
        this.$nextTick(() => $('#edit-participant-modal').modal('show'));
      },
      closeModal() {
        this.submitted = false;
        $('#edit-participant-modal').modal('hide');
      },
    },
  };
</script>
